// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3q6bw","image":"styles_image__Q6qER","iconDiv":"styles_iconDiv__r_9PA","drawerDiv":"styles_drawerDiv__2PAPn"};